import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { widgetData } from './Dashboard.data';
import Widget from '../components/common/Widget';
import { getAppVersionLabel } from '../helpers/appVersion';

const DashboardContainer = styled.div`
  padding: 40px;
  min-height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
`;

const WidgetsGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 32px;
  flex: 1;
`;

const VersionLabel = styled.span`
  display: block;
  margin-top: 24px;
  text-align: right;
  font-size: 12px;
  color: #94a3b8;
  user-select: none;
`;

// Mantenemos una animación de contenedor para la carga inicial
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
    },
  },
};

const DashboardPage: React.FC = () => {
  // ✅ 1. Estado para saber qué widget está enfocado
  const [focusedWidgetId, setFocusedWidgetId] = useState<string | null>(null);

  return (
    <DashboardContainer>
      <WidgetsGrid
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {widgetData.map((widget) => (
          // ✅ 2. Pasamos el estado y las funciones como props a cada Widget
          <Widget
            key={widget.title}
            data={widget}
            isFocused={focusedWidgetId === widget.title}
            isOtherFocused={focusedWidgetId !== null && focusedWidgetId !== widget.title}
            onFocus={() => setFocusedWidgetId(widget.title)}
            onBlur={() => setFocusedWidgetId(null)}
          />
        ))}
      </WidgetsGrid>
      <VersionLabel>{getAppVersionLabel()}</VersionLabel>
    </DashboardContainer>
  );
};

export default DashboardPage;